import { Form, Formik } from 'formik';
import React, { useCallback, useMemo } from 'react';
import {
  SpaceWrapper,
  Card,
  Button,
  BoldBodyText,
  Currency,
  Grid,
  BodyText,
  Header3Text,
  NumberInput,
  SpruceField,
} from 'ui-toolkit';
import { setLocale } from 'yup';
import yup from '../../validation/newQuotes/validation';

export interface ISplitTransactionCardProps {
  amountCents: number;
  findMatch: (matchOnAmount: number) => void;
  cancelSplit: () => void;
}

const validationSchemaFromCents = (amountCents: number) => {
  setLocale({
    number: {
      max: 'Split amount must be less than the remaining amount.',
    },
  });
  return yup.object({
    amountCents: yup.number().nullable().positive().max(amountCents),
  });
};

export const SplitTransactionCard: React.FC<ISplitTransactionCardProps> = ({ amountCents, findMatch, cancelSplit }) => {
  const validationSchema = useMemo(() => validationSchemaFromCents(amountCents), [amountCents]);

  const ref = useCallback((node: HTMLDivElement | null) => {
    if (node !== null) {
      node.scrollIntoView();
    }
  }, []);

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{ amountCents: undefined }}
      onSubmit={async (values) => findMatch(values.amountCents || 0)}
    >
      {({ values }) => (
        <Form>
          <SpaceWrapper leftSpace={'none'} rightSpace={'none'} ref={ref}>
            <Card>
              <Grid>
                <Header3Text>Create Split</Header3Text>
                <BodyText>Amount to apply to this split</BodyText>
                <SpruceField name={'amountCents'}>
                  {({ field }: any) => (
                    <NumberInput
                      {...field}
                      thousandSeparator={true}
                      decimalScale={2}
                      mode={'currency'}
                      placeholder={'Amount of Split'}
                      valueIsCents={true}
                    />
                  )}
                </SpruceField>
                <Grid columnCount={2} columnWidth={'max-content'}>
                  <Button type={'submit'} intent={'secondary'} disabled={!values.amountCents}>
                    Find Match
                  </Button>
                  <Button intent={'ghost'} onClick={cancelSplit}>
                    Cancel
                  </Button>
                </Grid>
                <BoldBodyText>Remaining Amount</BoldBodyText>
                <Currency value={amountCents - (values.amountCents || 0)} valueIsCents />
              </Grid>
            </Card>
          </SpaceWrapper>
        </Form>
      )}
    </Formik>
  );
};
